export const MAX_RELOAD_ATTEMPTS = 5;
export const RELOAD_DELAY_MS = 500;
